/**
 * 10.9ES — PAINEL "🆕 NOVIDADES" (aparece ao entrar no jogo depois de uma atualizacao).
 * Lista o que mudou em cada versao nao vista e mostra a recompensa somada. O unico botao
 * ("Resgatar e jogar") entrega a recompensa e fecha — nao da pra fechar e perder o premio.
 */
import { i18n } from "../i18n/i18n";
import type { ChangelogEntry } from "../config/Changelog";

export class UpdateNotes {
  private readonly root: HTMLDivElement;

  constructor(uiRoot: HTMLElement) {
    this.root = document.createElement("div");
    this.root.className = "overlay upd-overlay";
    this.root.hidden = true;
    uiRoot.appendChild(this.root);
  }

  get isOpen(): boolean { return !this.root.hidden; }

  open(entries: ChangelogEntry[], onClaim: (coins: number, diamonds: number) => void): void {
    const pt = i18n.locale === "pt-BR";
    const esc = (s: string): string => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const coins = entries.reduce((a, e) => a + e.reward.coins, 0);
    const dia = entries.reduce((a, e) => a + e.reward.diamonds, 0);
    const blocks = entries.map((e) => `
      <div class="upd-entry">
        <div class="upd-title">${esc(pt ? e.title.pt : e.title.en)} <span class="upd-date">${e.date.split("-").reverse().join("/")}</span></div>
        <ul class="upd-list">${e.items.map((it) => `<li>${esc(pt ? it.pt : it.en)}</li>`).join("")}</ul>
      </div>`).join("");
    const reward = [coins > 0 ? `🪙 ${coins.toLocaleString(pt ? "pt-BR" : "en-US")}` : "", dia > 0 ? `💎 ${dia}` : ""].filter(Boolean).join("  ·  ");
    this.root.innerHTML = `
      <div class="panel void-panel upd-panel">
        <h2 class="upd-h">🆕 ${esc(i18n.t("update.title"))}</h2>
        <div class="upd-body">${blocks}</div>
        ${reward ? `<div class="upd-reward">${esc(i18n.t("update.reward"))}<b>${reward}</b></div>` : ""}
        <button class="btn primary upd-claim">${esc(reward ? i18n.t("update.claim") : i18n.t("update.ok"))}</button>
      </div>`;
    this.root.hidden = false;
    this.root.querySelector<HTMLButtonElement>(".upd-claim")!.addEventListener("click", () => {
      this.root.hidden = true;
      onClaim(coins, dia);
    }, { once: true });
  }
}
